<template>
  <zt-modal
    class="rounded font-normal"
    :title="$t('message.main_bussines_page.workflow.modals.groups.title')"
    @close="closeDialog" max-width="600px"
    :active="active"
    :z-index="1001"
  >
    <template>
      <div class="flex px-10 py-12">
        <zt-accordion>
          <zt-accordion-item
            v-for="(team, i) in item.team_approvers"
            :title="team.team_approve_name"
            :class="[i === item.team_approvers.length -1 ? '' : 'mb-4']"
            prepend-icon="user-group"
            :disabled="true"
          >
            <div class="px-12 py-8"></div>
          </zt-accordion-item>
        </zt-accordion>
      </div>
    </template>
    <template #modal-footer>
      <div
        class="zt-modal-footer rounded-b flex justify-end items-center p-4"
      >
        <zt-button
          class="w-25"
          @click="closeDialog"
          data-vs-button="close-dialog"
        >
          {{
            $t('message.main_bussines_page.workflow.modals.groups.action')
          }}
        </zt-button>
      </div>
    </template>
  </zt-modal>
</template>
<script>
import Workflow from "@/apiClient/Workflow";

export default {
  name: 'ModalGroupListWorkflow',
  props: {
    active: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: () => ([])
    }
  },
  watch: {
    active() {
      this.isLoading = false
    }
  },
  data() {
    return {
      workflowInstance: new Workflow(),
      isLoading: false
    }
  },
  methods: {
    closeDialog() {
      this.$emit('close-group-modal')
    }
  }
}
</script>

<style scoped lang="scss">
.zt-modal-footer {
  background-color: #EEEEEE;
}
.text-custom-legend {
  font-size: 1.125rem;
}
::v-deep {
  .zt-modal {
    box-shadow: 0 3px 4px rgba(0, 0, 0, 0.14), 0 3px 3px rgba(0, 0, 0, 0.12),
    0 1px 8px rgba(0, 0, 0, 0.2);
  }
  .zt-modal.rounded {
    border-radius: .375rem!important;
  }
  button.button-cancel {
    color: #707070!important;
    background-color: transparent!important;
  }

  .zt-accordion-item {
    box-shadow: none!important;
    border: solid 1px #AAAAAA;
    .selected-disabled {
      cursor: default!important;
    }
    .selected-disabled > i {
      opacity: 0;
    }
  }
}
</style>
